import { atom } from "recoil";

export const searchReconcilliationData = atom({
  key: "searchReconcilliationData",
  default: {
    OfficeId: 0,
    ServiceAccountNo: "",
    BatchNo: 0,
    DateCreatedFrom: "",
    DateCreatedTo: "",
    Status: "Pending Reconcilliation",
    StoreNumber: "",
  },
});
